var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 22,
    height: 36,
    rx: 2,
    stroke: "#878787",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 30.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 34.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 30.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 34.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 30.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 34.5,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#878787",
    stroke: "#878787"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 27.5,
    width: 17,
    height: 15,
    rx: 0.5,
    transform: "rotate(-90 4.5 27.5)",
    stroke: "#878787"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5,
    y: 29.5,
    width: 21,
    height: 9,
    rx: 0.5,
    transform: "rotate(-90 22.5 29.5)",
    stroke: "#878787"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 30,
    width: 22,
    height: 2,
    transform: "rotate(-90 27 30)",
    fill: "#878787"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 1,
    width: 12,
    height: 6,
    rx: 2,
    fill: "white",
    stroke: "#878787",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.51961c682e395e199a96ae2414710ac1.svg";
export { ForwardRef as ReactComponent };